<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="options"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="loading"
          :style="{ opacity: loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay estados para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { listOptions } from '@/febos/servicios/api/opciones.api';

export default {
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    optionSelected() {
      return this.options.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled || !this.options.length || this.loading;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.options.find((option) => option.value === this.value);
    },
    async fetch(parentValue) {
      this.loading = true;
      const { data: { opciones: options } } = await listOptions({
        grupoOpcion: `estados-kanban.${parentValue}.item`,
        deshabilitado: 'no'
      });
      this.options = options
        .map((option) => ({
          id: option.opcionId,
          label: option.descripcion,
          value: option.valor,
          order: option.orden
        }))
        .sort((a, b) => a.order - b.order);
      this.loading = false;
    }
  },
  created() {
    if (this.parentValue) {
      this.$watch('parentValue', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if (oldValue !== '') {
            this.$emit('input', '');
          }
          this.fetch(newValue);
        }
      });

      this.fetch(this.parentValue);
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Estados' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    parentValue: { type: [String, Number] },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};

</script>
